module.exports = __webpack_public_path__ + "static/img/boj.2b3c539.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/boj.jpg
// module id = h4/E
// module chunks = 1